import { Link, useNavigate } from "react-router-dom";
import React from "react";
import {
  FileText,
  Calendar,
  Briefcase,
  Settings,
  PieChart,
  Layers,
  Truck,
  LogOut,
} from "lucide-react";
import "./Sidebar.css";

const Sidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  const cerrarSesion = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("usuario");
    navigate("/login");
    window.location.reload();
  };

  return (
    <aside className={`sidebar-modern ${isOpen ? "open" : ""}`}>
      <div className="sidebar-header">
  <button className="sidebar-close-button" onClick={onClose}>
    ✕
  </button>
  <Link to="/">
    <img
      src="/logo_movimonte_nuevo.png"
      alt="Logo Movimonte"
      className="sidebar-logo"
    />
  </Link>
</div>


      <nav className="sidebar-nav">
        <SidebarGroup
          icon={<FileText size={18} />}
          label="Facturación"
          items={[
            { label: "Subir Facturas", href: "/subir-factura-pdf" },
            { label: "Facturas Subidas", href: "/facturas-pdf" },
            { label: "Nueva Factura", href: "/nueva-factura" },
            { label: "Listar Facturas", href: "/listar-facturas" },
          ]}
        />
        <SidebarGroup
          icon={<Calendar size={18} />}
          label="Cotizaciones"
          items={[
            { label: "Crear Cotización", href: "/cotizacion" },
            { label: "Buscar Cotizaciones", href: "/buscar-cotizaciones" },
          ]}
        />
        <SidebarGroup
          icon={<Truck size={18} />}
          label="Vehículos"
          items={[
            { label: "Ingresar Vehículo", href: "/nuevo-equipo" },
            { label: "Ver Vehículos", href: "/listar-equipos" },
            { label: "Nueva Carga", href: "/nuevo-combustible" },
            { label: "Historial Rendimiento", href: "/rendimiento-historico" },
            { label: "Control Vehículos", href: "/control-vehiculos" },
          ]}
        />
        <SidebarGroup
          icon={<Briefcase size={18} />}
          label="Reportes"
          items={[
            { label: "Nuevo Reporte Maquinaria", href: "/nuevo-reporte" },
            { label: "Listar Reportes Maquinaria", href: "/listar-reportes" },
            { label: "Nuevo Reporte Camión", href: "/nuevo-reporte-camion" },
            { label: "Listar Reportes Camión", href: "/listar-reportes-camion" },
          ]}
        />
        <SidebarGroup
          icon={<Layers size={18} />}
          label="EDP"
          items={[
            { label: "EDP Interactivo", href: "/edp-interactivo" },
            { label: "Listado de EDPs", href: "/listar-edps" },
          ]}
        />
        <SidebarItem icon={<PieChart size={18} />} label="Gráficos" href="/graficos" />
        
        {/* Botón de Cerrar Sesión */}
        <button className="sidebar-logout" onClick={cerrarSesion}>
          <span className="sidebar-icon">
            <LogOut size={18} />
          </span>
          <span className="sidebar-text">Cerrar Sesión</span>
        </button>
      </nav>
    </aside>
  );
};

const SidebarItem = ({ icon, label, href }) => (
  <a className="sidebar-link" href={href}>
    <span className="sidebar-icon">{icon}</span>
    <span className="sidebar-text">{label}</span>
  </a>
);

const SidebarGroup = ({ icon, label, items }) => (
  <details className="sidebar-group">
    <summary>
      <span className="sidebar-icon">{icon}</span>
      <span className="sidebar-text">{label}</span>
    </summary>
    {items.map((item, idx) => (
      <a key={idx} className="sidebar-sublink" href={item.href}>
        {item.label}
      </a>
    ))}
  </details>
);

export default Sidebar;
